<template lang="html">
  <li class="card-item">
      <div class="card-control">
          <el-radio class="img-radio" :label="Card_type">
            {{Card_type}}款式
            <lazy-component >
            <img class="card-img" :src='Card_ImgPath' :alt="Card_type+'型号模板'">
            </lazy-component>
          </el-radio>
      </div>
  </li>
</template>

<script>
export default {
  data() {
    return {
      CardTypeAttr: {
        hasShopName: false,
        hasWifi: false,
        CardQrcodeCount: 1,
      },
    };
  },
  props: ["Card_type", "Card_ImgPath"],
};
</script>

<style lang="css">
.card-item {
  text-align: left;

  /* background: #f5f5f5; */
  border: 1px solid #d5d5d5;
  margin: 1em;
  border-radius: 2px;
  box-shadow: 0px 4px 15px 1px rgba(0, 0, 0, 0.13);
}
.card-img {
  max-width: 250px;
  height: 100px;
  display: block;
}
.img-radio {
  padding: 2rem;
  width: 100%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// QrcodeTypeCard.vue?dc7c20e8